/* eslint-disable import/no-anonymous-default-export */
import bg from '../assets/bg.webp';
import chef from '../assets/chef.webp';
import G from '../assets/G.webp';
import gallery01 from '../assets/gallery01.webp';
import gallery02 from '../assets/gallery02.webp';
import gallery03 from '../assets/gallery03.webp';
import gallery04 from '../assets/gallery04.webp';
import knife from '../assets/knife.webp';
import logo from '../assets/logo.webp';
import menu from '../assets/menu.webp';
import overlaybg from '../assets/overlaybg.webp';
import spoon from '../assets/spoon.webp';
import welcome from '../assets/welcome.webp';
import findus from '../assets/findus.webp';
import laurels from '../assets/laurels.webp';
import award01 from '../assets/award01.webp';
import award02 from '../assets/award02.webp';
import award03 from '../assets/award03.webp';
import award05 from '../assets/award05.webp';
import sign from '../assets/sign.webp';
import quote from '../assets/quote.webp';
import gericht from '../assets/gericht.webp';

export default { 
    bg, chef, G, gallery01, gallery02, gallery03, gallery04, knife, logo, menu, overlaybg, spoon, 
    welcome, findus, laurels, award01, award02, award03, award05, sign, quote, gericht 
}